"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var e = require("react"),
    t = require("@react-pdf-viewer/core");

function n(e) {
  if (e && e.__esModule) return e;
  var t = Object.create(null);
  return e && Object.keys(e).forEach(function (n) {
    if ("default" !== n) {
      var o = Object.getOwnPropertyDescriptor(e, n);
      Object.defineProperty(t, n, o.get ? o : {
        enumerable: !0,
        get: function get() {
          return e[n];
        }
      });
    }
  }), t.default = e, Object.freeze(t);
}

var o = n(e),
    r = function r() {
  return o.createElement(t.Icon, {
    size: 16
  }, o.createElement("path", {
    d: "M17.5,11.5c3.314,0,6,2.686,6,6s-2.686,6-6,6s-6-2.686-6-6S14.186,11.5,17.5,11.5z\n                M17.5,14.5v6\n                M17.5,20.5\n                l-2.25-2.25\n                M17.5,20.5l2.25-2.25\n                M10.5,23.5h-9c-0.552,0-1-0.448-1-1v-21c0-0.552,0.448-1,1-1h13.293\n                c0.265,0,0.52,0.105,0.707,0.293L19.207,4.5C19.395,4.687,19.5,4.942,19.5,5.207V8.5"
  }));
},
    _c = function c() {
  return (_c = Object.assign || function (e) {
    for (var t, n = 1, o = arguments.length; n < o; n++) {
      for (var r in t = arguments[n]) {
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
      }
    }

    return e;
  }).apply(this, arguments);
},
    l = {
  left: 0,
  top: 8
},
    i = function i(e) {
  var n = e.onClick,
      c = o.useContext(t.LocalizationContext),
      i = c && c.download ? c.download.download : "Download";
  return o.createElement(t.Tooltip, {
    position: t.Position.BottomCenter,
    target: o.createElement(t.Button, {
      onClick: n
    }, o.createElement(r, null)),
    content: function content() {
      return i;
    },
    offset: l
  });
},
    a = function a(e) {
  var t = e.children,
      n = e.fileNameGenerator,
      r = e.store,
      c = o.useState(r.get("file")),
      l = c[0],
      a = c[1],
      u = function u(e) {
    a(e);
  };

  o.useEffect(function () {
    return r.subscribe("file", u), function () {
      r.unsubscribe("file", u);
    };
  }, []);
  return (t || function (e) {
    return o.createElement(i, {
      onClick: e.onClick
    });
  })({
    onClick: function onClick() {
      var e, t, o, r;
      l && (e = l, t = n(l), o = "string" == typeof e.data ? "" : URL.createObjectURL(new Blob([e.data], {
        type: "application/pdf"
      })), (r = document.createElement("a")).style.display = "none", r.href = o || e.name, r.setAttribute("download", t), document.body.appendChild(r), r.click(), document.body.removeChild(r), o && URL.revokeObjectURL(o));
    }
  });
},
    u = function u(e) {
  var n = e.onClick,
      c = o.useContext(t.LocalizationContext),
      l = c && c.download ? c.download.download : "Download";
  return o.createElement(t.MenuItem, {
    icon: o.createElement(r, null),
    onClick: n
  }, l);
};

exports.DownloadIcon = r, exports.getFilePlugin = function (e) {
  var n = o.useMemo(function () {
    return t.createStore({});
  }, []),
      r = function r(e) {
    return "object" == typeof e.data ? "document.pdf" : (t = e.name, (n = t.split("/").pop()) ? n.split("#")[0].split("?")[0] : t);
    var t, n;
  },
      l = function l(t) {
    return o.createElement(a, _c({}, t, {
      fileNameGenerator: e && e.fileNameGenerator || r,
      store: n
    }));
  };

  return {
    onViewerStateChange: function onViewerStateChange(e) {
      return n.update("file", e.file), e;
    },
    Download: l,
    DownloadButton: function DownloadButton() {
      return o.createElement(l, null, function (e) {
        return o.createElement(i, _c({}, e));
      });
    },
    DownloadMenuItem: function DownloadMenuItem(e) {
      return o.createElement(l, null, function (t) {
        return o.createElement(u, {
          onClick: function onClick() {
            t.onClick(), e.onClick();
          }
        });
      });
    }
  };
};